// @flow

import * as React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';

import graph from 'app/lib/graph';

class DeleteUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false
    };
  }

  handleClose = () => this.setState({ modal: false });

  handleClick = () => {
    if (this.props.confirmation) {
      return this.setState({ modal: true });
    }
    this.props.onClick();
  };

  handleConfirmation = async () => {
    const user = this.props.user;
    const userId = user?.get?.('uuid') || user.uuid;

    const res = await graph(
      'mutation  DeleteUser($id: ID!) { deleteUser(id: $id) { expireAt } }',
      {
        id: userId
      }
    );

    if (res.data?.deleteUser) {
      this.props.onSubmit(res.data.deleteUser);
    }

    this.handleClose();
  };

  renderTriggerButton(deleteUserActionLabel) {
    return (
      <Button
        flat
        secondary
        tabIndex={-1}
        label={deleteUserActionLabel}
        onClick={this.handleClick}
        style={{ float: 'left' }}
      />
    );
  }

  render() {
    const deleteUserActionLabel = this.props.user.expireAt
      ? this.props.i18n('Aktiver brugeren')
      : this.props.i18n('Slet brugeren');

    if (this.props.confirmation) {
      const actions = this.state.password
        ? [
            <Button
              key="close"
              primary
              autoFocus
              label={this.props.i18n('Close')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />
          ]
        : [
            <Button
              key="cancel"
              secondary
              flat
              label={this.props.i18n('Cancel')}
              onClick={this.handleClose}
              style={{ marginLeft: '12px' }}
            />,
            <Button
              key="submit"
              primary
              autoFocus
              label={this.props.i18n('Confirm')}
              onClick={this.handleConfirmation}
              style={{ marginLeft: '12px' }}
            />
          ];

      return (
        <div>
          {this.state.modal ? (
            <Dialog
              open
              fullWidth
              fullScreen={this.props.fullScreen}
              onClose={this.handleClose}
              className="dialog-common"
            >
              <DialogTitle>{deleteUserActionLabel}</DialogTitle>
              <DialogContent>
                {this.props.user.expireAt
                  ? this.props.i18n('Genaktiver brugeren ved at trykke bekræft')
                  : this.props.i18n(
                      'Efter bekræftelse vil bruger blive sendt til sletning'
                    )}
              </DialogContent>
              <DialogActions>{actions}</DialogActions>
            </Dialog>
          ) : null}
          {this.renderTriggerButton(deleteUserActionLabel)}
        </div>
      );
    }

    return this.renderTriggerButton(deleteUserActionLabel);
  }
}

const DeleteUserI18n = i18n(DeleteUser);

function DeleteUserWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <DeleteUserI18n {...props} fullScreen={fullScreen} />;
}

export default DeleteUserWithMobileDialog;